  <div class="bgInicio">
    <div class="wrapper fadeInDown">
        <div id="formContent">
            <div class="fadeIn fourth">
                <img src="../../../assets/img/logo-vibe-branca.png">
            </div>
          <form style="padding:20px">
            <input type="text" class="form-control fadeIn second" [(ngModel)]="user.email" name="email" placeholder="email">
          <br>
            <input type="password" class="form-control fadeIn third" [(ngModel)]="user.password" name="senha" placeholder="senha">
          <br>
            <input (click)="auth.login(user)" type="submit" class="btn btn-primary fadeIn fourth" value="ENTRAR">
          </form>
        </div>
        <p>Um jeito único de viver<br> grandes <strong>momentos!</strong></p>
      </div>
      <div style="bottom:0;color:rgb(199, 199, 199);font-size: 0.6em;">Atualização: 04/03/2023</div>
  </div>